module.exports = __webpack_public_path__ + "static/media/19_r_shari_79.17_14.63.75363066.png";